import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import cx from "classnames";
import { CircularProgress, Typography } from "@mui/material";
import { ConfirmDialog } from "../../Modals";
import { RAK_SAVE_CLOSE_CONFIRM_MESSAGE } from "./constants";
import routes from "../../../routes";
import { NEXT } from "../../../constants";
import { useTrackingHistory } from "../../../utils/useTrackingHistory";
import { checkLoginStatus } from "../../../store/selectors/loginSelector";
import { StyledSaveCloseContainer, StyledSaveCloseButton } from "./styled";

export const SaveAndClose = ({
  prospectSaveOnClick,
  extraClasses,
  isSmallDeviceSaveCloseBtn = false,
  hideSaveCloseBtn = false
}) => {
  const pushHistory = useTrackingHistory();
  const isAgent = useSelector(checkLoginStatus);

  const [isDisplayConfirmDialog, setIsDisplayConfirmDialog] = useState(false);
  const [circularProgress, setCircularProgress] = useState(false);
  const [isMounted, setIsMounted] = useState(true);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  const handleSaveAndCloseClick = () => {
    setIsDisplayConfirmDialog(true);
  };

  const handleConfirm = useCallback(() => {
    setCircularProgress(true);
    prospectSaveOnClick(NEXT)
      .then(() => {
        if (isMounted) {
          setIsDisplayConfirmDialog(false);
          setCircularProgress(false);
          if (isAgent) {
            pushHistory(routes.searchProspect, true);
          } else {
            pushHistory(routes.comeBackLogin, true);
          }
        }
      })
      .catch(error => {
        console.log("Error while saving:", error);
        if (isMounted) {
          setIsDisplayConfirmDialog(false);
          setCircularProgress(false);
        }
      });
  }, [isMounted, setIsDisplayConfirmDialog, prospectSaveOnClick, pushHistory, isAgent]);

  const closeDialogHandler = useCallback(() => {
    setIsDisplayConfirmDialog(false);
    setCircularProgress(false);
  }, [setIsDisplayConfirmDialog]);

  return (
    <StyledSaveCloseContainer
      className={cx(extraClasses, isSmallDeviceSaveCloseBtn && "hideSaveCloseBtn")}
    >
      <div className={"saveButtonContainer"}>
        <StyledSaveCloseButton
          className={hideSaveCloseBtn ? "hideSaveCloseBtn" : ""}
          variant="outlined"
          onClick={handleSaveAndCloseClick}
        >
          Save and close
        </StyledSaveCloseButton>
        <ConfirmDialog
          disableBackdropClick
          disableEscapeKeyDown
          title={null}
          isOpen={isDisplayConfirmDialog}
          handleConfirm={handleConfirm}
          handleClose={closeDialogHandler}
          handleReject={closeDialogHandler}
          message={RAK_SAVE_CLOSE_CONFIRM_MESSAGE}
          cancelLabel="No"
          confirmLabel="Yes"
          divider={false}
          isDisplayBtnLoader={circularProgress}
        />
      </div>
      {circularProgress && (
        <div className={"saveCloseProgressContainer"}>
          <div className={"progressLayout"}>
            <CircularProgress className={"circularProgress"} value={null} />
            <Typography variant="h3" classes={{ root: "saveCloseLabel" }}>
              Saving your application
            </Typography>
          </div>
        </div>
      )}
    </StyledSaveCloseContainer>
  );
};

SaveAndClose.propTypes = {
  prospectSaveOnClick: PropTypes.func.isRequired,
  extraClasses: PropTypes.string,
  isSmallDeviceSaveCloseBtn: PropTypes.bool,
  hideSaveCloseBtn: PropTypes.bool
};
